module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/casa-mineira_mobile.7300d45e.svg";